import { useState, useEffect } from "react";
import { Wifi, WifiOff } from "lucide-react";
import { cn } from "@/lib/utils";
import { pwaManager } from "@/utils/pwaUtils";

interface NetworkStatusProps {
  showText?: boolean;
  className?: string;
}

export function NetworkStatus({
  showText = false,
  className,
}: NetworkStatusProps) {
  const [isOnline, setIsOnline] = useState(pwaManager.isOnline());
  const [showOfflineMessage, setShowOfflineMessage] = useState(false);

  useEffect(() => {
    const cleanup = pwaManager.onNetworkChange((online) => {
      setIsOnline(online);

      if (!online) {
        setShowOfflineMessage(true);
      } else if (showOfflineMessage) {
        // Show "back online" message briefly
        setTimeout(() => setShowOfflineMessage(false), 3000);
      }
    });

    return cleanup;
  }, [showOfflineMessage]);

  if (isOnline && !showOfflineMessage) {
    return null;
  }

  return (
    <div
      className={cn(
        "flex items-center gap-2 px-3 py-2 rounded-lg text-sm transition-all duration-300",
        isOnline
          ? "bg-success/20 text-success border border-success/30"
          : "bg-warning/20 text-warning border border-warning/30",
        className,
      )}
    >
      {isOnline ? (
        <Wifi className="w-4 h-4" />
      ) : (
        <WifiOff className="w-4 h-4" />
      )}

      {showText && (
        <span className="font-medium">
          {isOnline ? "Back online" : "You're offline"}
        </span>
      )}
    </div>
  );
}
